<template>
  <div id="card-element"/>
</template>

<script>
import { injectScript } from '@/helpers/scriptInjection';

export default {
  name: 'StripeCard',
  props: {
    publicKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      stripe: {},
      cardInput: '',
      token: '',
      cardError: '',
    };
  },
  watch: {
    cardError(cardError) {
      this.$emit('handle-error', cardError);
    },
  },
  mounted() {
    injectScript('Stripe', 'https://js.stripe.com/v3/')
      .then(() => this.configureStripe())
      .catch(() => {
        this.cardError = 'Unable to load Stripe.';
      });
  },
  methods: {
    configureStripe() {
      this.stripe = window.Stripe(this.publicKey);
      const elements = this.stripe.elements({
        fonts: [
          {
            family: '"Montserrat"',
            src: "local('Montserrat Regular'), local('Montserrat-Regular'), url(https://fonts.gstatic.com/s/montserrat/v12/JTUSjIg1_i6t8kCHKm459Wlhyw.woff2) format('woff2')",
            unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD',
          },
        ],
      });

      const style = {
        base: {
          color: '#141c20',
          fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Ubuntu,sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '14px',
          '::placeholder': {
            color: '#7c8b91',
          },
        },
        invalid: {
          color: '#FF5B61',
          iconColor: '#FF5B61',
        },
      };

      // Create an instance of the card Element.
      this.cardInput = elements.create('card', { style, hidePostalCode: true });
      this.cardInput.mount('#card-element');

      // Handle real-time validation errors from the card Element.
      this.cardInput.addEventListener('change', (event) => {
        if (event.error) {
          this.cardError = event.error.message;
        } else {
          this.cardError = '';
        }

        if (event.complete) {
          this.$emit('complete');
        } else {
          this.$emit('incomplete');
        }
      });

      this.cardInput.addEventListener('submit', (event) => {
        this.$emit('submit');
      });
    },
    getStripeToken(callback) {
      this.cardError = '';
      this.stripe.createToken(this.cardInput).then((result) => {
        if (result.error) {
          this.cardError = result.error.message;
        } else {
          this.token = result.token.id;
          callback();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.StripeElement {
  border: solid 1px #cfd8dc;
  border-radius: 5px;
  box-shadow: 0 1px 3px 0 rgb(48 54 70 / 10%);
  padding: 7px 10px;
  background-color: $white;

  &--focus {
    border: 1px solid #cfd8dc !important;
    box-shadow: 0 0 0 3px #bfdeff !important;
  }

  &--webkit-autofill {
    background-color: $lightGray  !important;
  }
}
</style>
